<zs-tag class="zs-tag" value={{value}} dismissable={{dismissable}} nonclickable={{nonclickable}} [ngClass]="customClass">
  <ng-content select="[tag-value]"></ng-content>
  @if (dismissable) {
    <a class = 'zs-interactive-primary' close (click)="onRemove()">
      <span class="zs-icon zs-icon-close-circle-fill" ></span>
    </a>
  }
</zs-tag>